module.exports = __webpack_public_path__ + "img/25.8ed828f4.png";